import { render, staticRenderFns } from "./CustomerDetailsCard.vue?vue&type=template&id=267f57cc&scoped=true&"
import script from "./CustomerDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailsCard.vue?vue&type=style&index=0&id=267f57cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f57cc",
  null
  
)

export default component.exports